import React from 'react'
import Education from './../education'
import ListLevelHeader from '../../../components/utils/list-element-header'
import TextInput from '../../../components/text-input'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/free-solid-svg-icons'
import LevelBar from '../../../components/level-bar'

class SkillComponent extends Education {
  constructor(props) {
    super(props)

    this.state = {
      model: this.props.model,
      showBody: false,
      showExperience: this.props.showExperience,
    }
  }

  render() {
    let alternative = this.state.model.level
    alternative = alternative.charAt(0).toUpperCase() + alternative.slice(1)

    if (!this.state.showExperience) alternative = ''

    return (
      <React.Fragment>
        <div className="education-container">
          <div className="education-header" onClick={this.toggleBody}>
            <ListLevelHeader what={this.state.model.name} alternative={alternative} />

            <div className="education-header-title education-header-arrow">{this.showArrow()}</div>
          </div>
          <div className={`education-body ${this.state.showBody ? 'open' : 'closed'}`}>
            <div className="section-basics-line">
              <TextInput
                field="name"
                label="Skill"
                value={this.state.model.name}
                update={this.update}
              />

              <LevelBar
                field="level"
                enabled={this.state.showExperience}
                label="Level"
                value={this.state.model.level}
                update={this.update}
              />
            </div>
            <div className="button-remove-element" onClick={this.removeElement}>
              <FontAwesomeIcon icon={faTrash} />
            </div>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

SkillComponent.defaultProperties = { open: false, showExperience: false }
export default SkillComponent
